import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { Button, Card, Field, Input, Notice } from "../components/ui";
import { api, ApiError } from "../lib/api";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!username.trim() || !password) {
      setError("Enter both username and password.");
      return;
    }
    setLoading(true);
    try {
      await api.login(username.trim(), password);
      navigate("/admin");
    } catch (err) {
      if (err instanceof ApiError) setError(err.message);
      else setError("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-black px-5 py-16">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="mb-6 inline-flex items-center gap-2 text-sm text-wandor-muted transition-colors hover:text-wandor-prompt"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Back to the event portal
        </Link>

        <Card className="p-8">
          <div className="flex items-center gap-3">
            <div className="rounded-full bg-wandor-prompt/12 p-2.5">
              <Lock className="h-5 w-5 text-wandor-prompt" aria-hidden="true" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-white">Committee login</h1>
              <p className="text-sm text-wandor-muted">BBA Freshers 2026 · administrators only</p>
            </div>
          </div>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <Field label="Username" htmlFor="admin-username">
              <Input
                id="admin-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                maxLength={64}
              />
            </Field>
            <Field label="Password" htmlFor="admin-password">
              <Input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                maxLength={256}
              />
            </Field>

            {error && <Notice tone="error">{error}</Notice>}

            <Button type="submit" loading={loading} className="w-full" size="lg">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
